import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  FETCH_JOB_CANDIDATES,
  FETCH_JOB_CANDIDATE_REQUEST,
} from "./actionType";

import {
  fetchJobCandidatesSuccess,
  fetchJobCandidatesFailure,
  fetchJobCandidateIdSuccess,
  fetchJobCandidateIdFailure,
} from "./action";
import {
  fetchJobCandidates,
  fetchJobCandidate,
} from "../../helpers/backend_helper";

function* fetchJobCandidatesSaga(action) {
  try {
    const response = yield call(fetchJobCandidates, action.payload);
    yield put(fetchJobCandidatesSuccess(response));
  } catch (error) {
    yield put(fetchJobCandidatesFailure(error));
  }
}

function* fetchJobCandidateSaga(action) {
  try {
    const response = yield call(fetchJobCandidate, action.payload);
    yield put(fetchJobCandidateIdSuccess(response));
  } catch (error) {
    yield put(fetchJobCandidateIdFailure(error));
  }
}

export default function* watchInterviewForm() {
  yield takeEvery(FETCH_JOB_CANDIDATES, fetchJobCandidatesSaga);
  yield takeLatest(FETCH_JOB_CANDIDATE_REQUEST, fetchJobCandidateSaga);
}
